import request from '@/utils/request'
import qs from 'qs'

const getMyMessageById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/${id}`,
    method: 'get'
  })
}

const getMyMessagePageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/page-list`,
    method: 'get',
    params: query
  })
}

// function createMyMessage(data) {
//   return request({
//     url: `${process.env.VUE_APP_BOYUAN_API}/my-message`,
//     method: 'post',
//     data
//   })
// }

// const updateMyMessage = (id, data) => {
//   return request({
//     url: `${process.env.VUE_APP_BOYUAN_API}/my-message/${id}`,
//     method: 'put',
//     data
//   })
// }

const updateHasRead = (ids) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/has-read`,
    method: 'put',
    data: ids
  })
}

const deleteMyMessage = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/${id}`,
    method: 'delete'
  })
}

const deleteMyMessages = (ids) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/s`,
    method: 'delete',
    params: { ids },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

const deleteMyMessageAll = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/all`,
    method: 'delete',
  })
}

const updateHasReadAll = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/my-message/has-read-all`,
    method: 'put',
  })
}

export default {
  // createMyMessage,
  // updateMyMessage,
  getMyMessageById,
  getMyMessagePageList,
  updateHasRead,
  deleteMyMessage,
  deleteMyMessages,
  deleteMyMessageAll,
  updateHasReadAll
}
